import React from 'react'

function AddChequeFormStyle() {
  return (
    <style jsx='true'>
    {`
      #add-cheque-form-container {
        display: flex;
        height: 70vh;
      }

      /*********** Add Cheque Form Block ****************/
      #add-cheque-form-block-container {
        border-right: solid 0.5px grey;
        flex: 1;
        margin-right: 5px;
      }
      #add-cheque-form-block {
        display: flex;
        flex-direction: column;
      }
      #add-cheque-header-label {
        padding: 10px;
        font-size: 1.1rem;
        background-color: orange;
      }
      /*********** Input ************/
      .input-container {
        display: flex;
        flex-direction: column;
        padding: 5px;
      }
      .input-label {
        font-size: 1rem;
        flex: 1;
      }
      .input-data {
        font-size: 1rem;
        flex: 3;
        padding: 8px;
      }
      #cheque-button-group-container {
        /*float: right;*/
        display: flex;
        margin-top: 10px;
        margin-right: 5px;
        justify-content: flex-end;
      }

      /*
      #add-cheque-button {
        float: right;
        margin-top: 10px;
        margin-right: 5px;
      }
      */


      /******************* Cheque List Block ******************/
      #cheques-list-block {
        flex: 1.5;
        display: flex;
        flex-direction: column;
      }
      #cheque-items-container {
        padding: 10px;
        display: flex;
        flex-direction: column;
        font-size: 1rem;
        border: inset 1px;
        height: 70vh;
        overflow: auto;
      }
      .cheque-item {
        border: solid 0.2px lightgrey;
        background-color: white;
        display: grid;
        height: 20vh;
        margin-bottom: 10px;
        grid-template-columns: 1fr 1fr auto;
        grid-template-rows: auto 1fr;
        padding: 5px;
      }
      .cheque-item:hover {
        color: blue;
        cursor: pointer;
        /*background-color: rgba(153, 23, 100, 1);*/
        background-color: whitesmoke;
        transform: scale(1.01);
        /*transition: all 0.15s ease-in-out;*/
      }
      .cheque-item-highlight {
        color: blue;
        cursor: pointer;
        background-color: whitesmoke;
        transform: scale(1.01);
      }
      .cheque-number, .cheque-date{
        font-family: 'Courier New';
        font-size: 0.8em;
        padding: 10px;
      }
      .bank-and-amount-container {
        display: flex;
        flex-direction: column;
        grid-column: 1 / 4;
        justify-content: center;
      }
      .bank-name, .cheque-amount {
        text-align: center;
      }
      .bank-name {
        font-size: 1em;
      }
      .cheque-amount {
        font-size: 1.3em;
        font-weight: bold;
      }
      .pospro-action-btn.close-btn {
        margin-right: 10px;
      }
      #cheque-summary-container {
        display: flex;
        font-size: 0.8rem;
        padding: 10px;
      }
      #cheque-total-item {
        flex: 1;
      }
      #cheque-total-amount {
        flex: 1;
        text-align: right;
      }

      /************* Action button container *************/
      #action-button-container {
        margin-top: 10px;
        display: flex;
        justify-content: flex-end;
      }

    `}
    </style>
  )
}

export default React.memo(AddChequeFormStyle)
